export const VERSION = 'v1';

/** APIリクエストのエラーコード */
export const ERROR_CODE = {
  UNAUTHORIZED: 401,
  TIMEOUT: 504,
  TYPE: 999,
};

/** カスタムエラーコード */
export const CUSTOM_ERROR_CODE = {
  ACCOUNT_LOCK: 'ADB-P002',
  NO_TEMPLATE: 'AAA-P003',
};

/** インターフェース仕様書に対応するAPI番号 */
export const API_CODE = {
  REPAIR_REQUEST: '1',
  REPAIR_REQUEST_LIST: '2',
  INSPECTION_TOP: '3',
  INSPECTION_TYPE_LABELS: '4',
  INSPECTION_TYPE: '5',
  CONFIRMED_INSPECTION: '7',
  PARTS_SELECTION: '8',
  USER_INFO: '9',
  CATEGORY_MASTER: '10',
  TYPE_MASTER: '11',
  ITEM_MASTER: '12',
  INSPECTION_JUDGEMENTS: '13',
  TEMPLATE_MASTER: '14',
  TEMPLATE_ITEM_MASTER: '15',
  STATUS: '16',
  QC_TOP: '17',
  QC_TYPE_LABELS: '18',
  QC_TYPE: '19',
  CONFIRMED_QC: '20',
  REPORT: '22',
  QC_ALL: '23',
  ACCOUNT_INFO: '24',
  AUTH: '25',
  LOGIN: '26',
  LOGOUT: '27',
  BLOB_DATA: '28',
  DELETE_FILES: '29-1',
  UPLOAD_FILE_STAGE: '29-2',
  UPLOAD_FILE_COMMIT: '29-3',
  TEMP_DATA_REFLECTION: '32',
  P_CODE_MASTER: '33',
  F_CODE_MASTER: '34',
  R_CODE_MASTER: '35',
  R_CODE_PARTS_MASTER: '36',
  SEND_EXFM: '37-1',
  UPLOAD_FILE_EXFM: '37-2',
  MODEL_ATTRIBUTE_MASTER: '38',
  ITEM_MODEL_CRITERIA_MASTER: '39',
  MODEL_NAME_LIST: '40',
  MARKET_CODE_LIST: '41',
  ATTRIBUTE_MASTER: '42',
  OPERATION_HISTORY: '43',
  PARTS_NO_LIST: '44',
  REPORT_FORMAT: '45',
};
